import { inviewObserver } from '@utilities/inview';
const INVIEW_HOOK = '[js-hook-inview]';
const DEFAULT_INVIEW_CLASS = 'is--in-view';
const DEFAULT_OUTVIEW_CLASS = 'is--out-of-view';

/**
 * Basic inview controller that triggers an inview class based upon if an element is or out of view.
 */
export const inViewController = () => {
    const elements = [...(document.querySelectorAll(INVIEW_HOOK) as any)];

    elements.forEach(element => {
        inviewObserver.observe(element, isVisible => {
            const {
                inView = DEFAULT_INVIEW_CLASS,
                outView = DEFAULT_OUTVIEW_CLASS,
            } = element.dataset;

            if (isVisible) {
                element.classList.add(inView);
                element.classList.remove(outView);
            } else {
                element.classList.remove(inView);
                element.classList.add(outView);
            }
        });
    });
};
